import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private isDarkTheme: BehaviorSubject<boolean>;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.isDarkTheme = new BehaviorSubject<boolean>(
      localStorage.getItem('isDarkTheme') === 'true'
    );
  }

  setDarkTheme(isDarkTheme: boolean) {
    this.isDarkTheme.next(isDarkTheme);
    localStorage.setItem('isDarkTheme', this.isDarkTheme.value.toString());
  }

  getDarkTheme(): Observable<boolean> {
    return this.isDarkTheme;
  }

  loadTheme(): Promise<any> {
    return this.load().then(
      data => {
      }
    );
  }

  load() {
    const promise = new Promise((resolve, reject) => {
      const head = this.document.getElementsByTagName('head')[0];
      const style = this.document.createElement('link');
      style.rel = 'stylesheet';
      if (this.document.referrer != '') {
        const hostName = new URL(this.document.referrer).hostname;
        console.log('-------hostName--', hostName);
        if (hostName != 'undefined' && hostName != null && hostName != '') {
          if (hostName == 'childdiscipleship.com') {
            localStorage.setItem('sourceApp', 'resilientdisciples');
            localStorage.setItem('utm_source', 'resilientapp');
            style.href = 'resilientdisciples.css';
          } else if (hostName == 'britecurriculum.com') {
            localStorage.setItem('sourceApp', 'britecurriculum');
            localStorage.setItem('utm_source', 'briteapp');
            style.href = 'britecurriculum.css';
          } else if (hostName == environment.missionarySiteHost) {
            localStorage.setItem('utm_source', 'missionaryapp');
            localStorage.setItem('sourceApp', 'default');
            style.href = 'theme.css';
          } else {localStorage.setItem('utm_source', 'emapp');
            localStorage.setItem('sourceApp', 'default');
            style.href = 'theme.css';
          }
        }
      } else {
        if (localStorage.getItem('sourceApp') != null) {
          let appName = localStorage.getItem('sourceApp');
          if (appName == 'resilientdisciples') {
            localStorage.setItem('sourceApp', 'resilientdisciples');
            style.href = 'resilientdisciples.css';
          } else if (appName == 'britecurriculum') {
            localStorage.setItem('sourceApp', 'britecurriculum');
            style.href = 'britecurriculum.css';
          } else {
            localStorage.setItem('sourceApp', 'default');
            style.href = 'theme.css';
          }
        } 
      }
      head.appendChild(style);
      resolve(true);
    });
    return promise;
  }

}
